import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=71ff843a&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=71ff843a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff843a",
  null
  
)

export default component.exports